import { getTagsLabelsForPointType } from './pointtypes';

/**
 * This function adds fields to a bare equipment object from the store in order
 * to prepare it for display by components
 */
export function getEquipment(state, id) {
  const equipment = { id, ...state.entities.equipment.byId[id] };
  const devices = state.entities.devices.byId;

  // join with the points store
  equipment.points = [];
  for (let j = 0; j < equipment.pointIds?.length; j += 1) {
    const pointId = equipment.pointIds[j];
    const point = state.entities.points.byId[pointId];
    if (point) {
      // let's also include the tags & labels for the points
      const tagsLabels = getTagsLabelsForPointType(state, point.pointTypeId);
      point.tags = tagsLabels.tags;
      point.labels = tagsLabels.labels;

      point.device = devices[point.promotedDeviceId?.toString()];
      equipment.points.push(point);
    }
  }

  const type = state.entities.equipTypes.byId[equipment.equip_type_id];
  equipment.labels = type?.labels;
  equipment.display = {
    fullName: equipment.name,
  };

  if (!equipment.tags) {
    equipment.tags = [];
  }
  return equipment;
}
